// src/services/clientFileService.js
import api from './api';

const BASE = (clientId) => `/clients/${clientId}/files`;

export default {
  list: (clientId, params) =>
    api.get(BASE(clientId), {
      params: {
        functionCode: 'CLIENT_FILE_VIEW',
        ...params
      }
    })
    .then(r => r.data),

  upload: (clientId, file, onProgress) => {
    const form = new FormData();
    form.append('file', file);
    return api.post(
      BASE(clientId),
      form, {
        headers: {
          'Content-Type': 'multipart/form-data',
          /* 'X-No-Global-Loading': '1' */
        },
        params: {
          functionCode: 'CLIENT_FILE_UPLOAD'
        },
        onUploadProgress: evt => {
          if (evt.total && onProgress) onProgress(Math.round((evt.loaded / evt.total) * 100));
        }
      }
    ).then(r => r.data);
  },

  remove: (clientId, fileId) =>
    api.delete(`${BASE(clientId)}/${fileId}`, {
      data: {
        functionCode: 'CLIENT_FILE_DELETE'
      }
    }),

  // ⬇︎ NOUVEAU : téléchargement via Axios (avec Authorization)
  download: (clientId, fileId) =>
    api.get(`${BASE(clientId)}/${fileId}/download`, {
      params: {
        functionCode: 'CLIENT_FILE_VIEW'
      },
      responseType: 'blob'
    }).then(res => {
      // Essaye d’extraire le nom depuis Content-Disposition
      const dispo = res.headers['content-disposition'] || '';
      const m = /filename\*?=(?:UTF-8'')?["']?([^"';]+)["']?/i.exec(dispo);
      const filename = m ? decodeURIComponent(m[1]) : `fichier_${fileId}`;
      return {
        blob: res.data,
        filename
      };
    }),

  // (Tu peux garder downloadUrl si tu veux, mais ne l’utilise plus pour <a href>)
  downloadUrl: (clientId, fileId) =>
    `${api.defaults.baseURL}${BASE(clientId)}/${fileId}/download?functionCode=CLIENT_FILE_VIEW`,

  storageInfo: () =>
    api.get('/storage/info', {
      params: {
        functionCode: 'CLIENT_FILE_VIEW'
      }
    })
    .then(r => r.data),
};